/**
 * Deprecated.
 * Auto-gift logic moved to assets/buy-x-get-y.js.
 * Keep this file as a safety placeholder to avoid accidental reactivation.
 */
(function() {
  if (window.__AUTO_GIFT_DEPRECATED_LOGGED__) return;
  window.__AUTO_GIFT_DEPRECATED_LOGGED__ = true;
  console.warn("[auto-gift.js] Deprecated. Use assets/buy-x-get-y.js instead.");
})();